import React, { useState, useEffect } from "react";
import { FaPoundSign } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { FaMinus, FaPlus } from "react-icons/fa";
import api from "../../../utils/api.js";
import { toast } from "react-toastify";
import { showCustomAlert } from "../../User/Signup/Toast.jsx";
import { addToCart } from "../../../redux/action/cart.js";
import Cookies from 'js-cookie';

function Modal({ data, onClose, allProducts, allCategory }) {
  const [quantity, setQuantity] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [menuOptions, setMenuOptions] = useState([]);
  const [limitOfChoosenOptions, setLimitOfChoosenOptions] = useState(0);

  const drinkCategoryId = allCategory.find(
    (category) => category.title.toLowerCase() === "drinks"
  )?._id;
  const desertCategoryId = allCategory.find(
    (category) => category.title.toLowerCase() === "desserts"
  )?._id;

  const { cart } = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await api.get(`/option/menu/${data._id}?populate=menuId`);
        
        let optionsArray = [];
        if (response.data && typeof response.data === 'object') {
          for (let key in response.data) {
            if (!isNaN(key) && response.data[key] && response.data[key]._id) {
              optionsArray.push(response.data[key]);
            }
          }
        }
        setMenuOptions(optionsArray);
        
        if (data.limitOfChoosenOptions) {
          setLimitOfChoosenOptions(data.limitOfChoosenOptions);
        }
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    };
    
    if (data._id) {
      fetchOptions();
    }
  }, [data._id, data.limitOfChoosenOptions]);

  const RestaurantSavedId = JSON.parse(localStorage.getItem('selectedRestaurantId'));
  const statusRes = Cookies.get(`restaurantStatus_${RestaurantSavedId}`);

  const handleOptionToggle = (option) => {
    const isSelected = selectedOptions.some(opt => opt._id === option._id);
    
    if (isSelected) {
      setSelectedOptions(selectedOptions.filter(opt => opt._id !== option._id));
    } else {
      if (limitOfChoosenOptions > 0 && selectedOptions.length >= limitOfChoosenOptions) {
        toast.error(`You can only select up to ${limitOfChoosenOptions} options`);
        return;
      }
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const addToCartHandler = () => {
    if (statusRes === 'closed') {
      showCustomAlert({
        title: 'Restaurant is closed!',
        html: '<p style="color: #555;">Restaurant is not accepting order right now</p>',
        icon: 'success',
        confirmButtonText: 'ok',
        confirmButtonColor: '#af313d',
        background: '#ffffff',
        timer: 4000,
      });
    } else {
      // Create a unique ID that combines menu item ID and selected options
      const optionsId = selectedOptions.map(opt => opt._id).sort().join('-');
      const uniqueId = optionsId ? `${data._id}-${optionsId}` : data._id;

      // Format the name with selected options
      const optionsText = selectedOptions.length > 0 
        ? ` (${selectedOptions.map(opt => opt.name).join(', ')})`
        : '';
      const itemName = `${data.name}${optionsText}`;

      // CHANGED: Calculate price - if options are selected, use only options price
      // If no options selected, use base price
      let itemPrice = 0;
      if (selectedOptions.length > 0) {
        // Only options price when options are selected
        itemPrice = selectedOptions.reduce((total, opt) => total + (opt.price || 0), 0);
      } else {
        // Base price when no options selected
        itemPrice = data.price || 0;
      }

      const cartItem = {
        ...data,
        _id: uniqueId,
        name: itemName,
        quantity: quantity,
        productId: data._id,
        image: data.images[0],
        basePrice: itemPrice,
        price: itemPrice,
        selectedOptions: selectedOptions.map(opt => ({
          _id: opt._id,
          name: opt.name,
          price: opt.price
        }))
      };

      const existingCart = JSON.parse(localStorage.getItem('cartItems')) || [];
      const isItemExists = existingCart.find((i) => i._id === uniqueId);

      if (!isItemExists) {
        dispatch(addToCart(cartItem));
        const updatedCart = [...existingCart, cartItem];
        localStorage.setItem('cartItems', JSON.stringify(updatedCart));
      } else {
        const updatedProduct = {
          ...isItemExists,
          quantity: isItemExists.quantity + quantity,
        };

        dispatch(addToCart(updatedProduct));
        const updatedCart = existingCart.map((item) =>
          item._id === uniqueId ? updatedProduct : item
        );
        localStorage.setItem('cartItems', JSON.stringify(updatedCart));
      }

      onClose();
    }
  };

  const get = JSON.parse(localStorage.getItem('storeWorkingHour'));
  console.log(get?.weeks);

  const calculateTotalPrice = () => {
    // CHANGED: Same logic as in addToCartHandler
    let itemPrice = 0;
    if (selectedOptions.length > 0) {
      // Only options price when options are selected
      itemPrice = selectedOptions.reduce((total, opt) => total + (opt.price || 0), 0);
    } else {
      // Base price when no options selected
      itemPrice = data.price || 0;
    }
    return itemPrice * quantity;
  };

  const formatTime = (time) => {
    if (!time || time.trim() === "") {
      return null;
    }

    const [hour, minute] = time.split(":");
    
    if (isNaN(hour) || isNaN(minute)) {
      return null;
    }

    const formattedTime = new Date(0, 0, 0, hour, minute).toLocaleTimeString(
      "en-US",
      {
        hour: "numeric",
        minute: "2-digit",
      }
    );

    return formattedTime;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative lg:w-full md:w-full w-[80%] md:h-[90%] h-[60%] lg:max-w-2xl mt-6 md:max-w-[86%] px-4 rounded-3xl shadow-2xl md:p-8 overflow-x-hidden bg-white">
        <button
          onClick={onClose}
          className="absolute top-3 right-6 bg-black rounded-full md:w-10 md:h-10 w-6 h-6 items-center justify-center flex text-xl text-white font-bold hover:text-black hover:bg-white"
        >
          <FiX />
        </button>
       
        <div className="flex flex-wrap gap-5 justify-between items-center md:mt-10 mt-16 max-md:mr-1 max-md:max-w-full">
          <div className="flex flex-col items-start text-xl leading-loose text-zinc-500 max-md:max-w-full">
            <h1 className="self-stretch lg:text-[36px] text-[18.1px] sm:text-[18.1px] md:text-[24.9px] font-bold body leading-none text-black max-md:max-w-full">
              {data?.name}
            </h1>
          </div>
          <div className="lg:text-[32px] body font-bold text-[18px] sm:text-[18.1px] mdleading-none text-right text-[#C97C2A] ">
            <p className=" text-[#C97C2A] flex items-center justify-center">
              <FaPoundSign className="mr-1 md:text-[23px]" />{" "}
              <span className="text-[23px]">{data.price}</span>
            </p>
          </div>
        </div>

        <div className="flex items-start justify-between gap-2 mt-4">
          <div className="w-full">
            {/* Options selection with limit indicator */}
            {menuOptions.length > 0 && (
              <div className="mb-4">
                <h3 className="text-lg font-semibold mb-2">
                  Add-on Options {limitOfChoosenOptions > 0 && 
                    `(Select up to ${limitOfChoosenOptions})`}
                </h3>
                {limitOfChoosenOptions > 0 && (
                  <p className="text-sm text-gray-600 mb-3">
                    Selected: {selectedOptions.length}/{limitOfChoosenOptions}
                  </p>
                )}
                
                {menuOptions.map((option) => (
                  <div 
                    key={option._id}
                    className={`p-3 border rounded-md cursor-pointer mb-2 ${
                      selectedOptions.some(opt => opt._id === option._id) 
                        ? 'border-[#AF313D] bg-first bg-opacity-10' 
                        : 'border-gray-300'
                    } ${
                      limitOfChoosenOptions > 0 && 
                      selectedOptions.length >= limitOfChoosenOptions && 
                      !selectedOptions.some(opt => opt._id === option._id)
                        ? 'opacity-50 cursor-not-allowed'
                        : ''
                    }`}
                    onClick={() => handleOptionToggle(option)}
                  >
                    <div className="flex justify-between items-center">
                      <span className="font-medium">{option.name}</span>
                      <span className="text-first font-bold">+£{option.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            
            <div className="text-[#808080] text-[9.52px] sm:text-[9.52px] md:text-[13.1px] lg:text-[18.93px]">
              <p className="mt-5 w-full">{data.description}</p>
            </div>
          </div>

          <div className="w-[50%] flex justify-center items-center mt-4 lg:mt-0">
            <div className="md:h-[18rem] md:w-[18rem] lg:h-[18rem] lg:w-[18rem] h-[10rem] w-[10rem] rounded-full overflow-hidden flex justify-center items-center">
              <img
                loading="lazy"
                src={data.images[0]}
                className="h-full w-full object-cover"
                alt="Product image"
              />
            </div>
          </div>
        </div>

        <div className="flex mb-3 items-center justify-between flex-wrap text-center lg:gap-5 sm:gap-4 gap-4 mt-16 w-full font-bold">
          <div className="flex md:gap-5 gap-1 items-center text-xl text-center whitespace-nowrap rounded-none text-neutral-700 w-[160px] md:w-[222px]">
            <div
              onClick={() => quantity > 1 && setQuantity(quantity - 1)}
              style={{
                backgroundColor: quantity > 1 ? "#D2D1CD" : "#f0f0f0",
                borderRadius: "8px",
              }}
              className="flex items-center justify-center"
            >
              <button aria-label="Decrease quantity p-2">
                <FaMinus className={`text-3xl p-2 ${quantity > 1 ? 'text-white' : 'text-gray-400'}`} />
              </button>
            </div>
            <div className="my-auto tex-[6.07px] sm:text-[12.07px] lg:text-[20px] md:text-[13.99px] font-baloo font-semibold">
              {quantity}
            </div>
            <div
              onClick={() => setQuantity(quantity + 1)}
              style={{
                backgroundColor: "#AF313D",
                borderRadius: "8px",
              }}
              className="flex items-center justify-center"
            >
              <button aria-label="Increase quantity">
                <FaPlus className="text-white text-3xl p-2" />
              </button>
            </div>
          </div>
          
          <button
            className={`flex items-center justify-center gap-2.5 py-4 pr-9 pl-10 sm:text-[13.48px] text-[13.48px] md:text-[13.83px] lg:text-[20px] leading-tight body text-white rounded-[31px] shadow-[0px_24px_64px_rgba(0,0,0,0.12)] max-md:px-5 bg-[#AF313D]`}
            onClick={addToCartHandler}
          >
            <span className="flex items-center justify-center gap-2">
              Add to Cart
              <p className="text-md gap-1 md:text-lg flex items-center justify-center">
                <FaPoundSign size={15} /> {calculateTotalPrice().toFixed(2)}
              </p>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Modal;